import { useContext, useEffect, useState } from "react";
import { BsArrowClockwise, BsCaretLeftFill, BsCaretRightFill, BsCheck2Square } from "react-icons/bs";
import { useSelector } from "react-redux";
import { EnquiryGridSelectionContext } from "../../../contexts/enquiry-grid-selection.context";
import useInterval from "../../../hooks/useInterval";
import { useWindowResize } from "../../../hooks/useWindowResize";
import { getEnquiryById } from "../../../interfaces/enquiryList";
import { burgerMenuMatchLeftPanePos } from "../../../Logic/BurgerMenu";
import { ActivateWizardModule } from "../../../Logic/Enquiries/activateWizard";
import { LoadActiveMyEnquiries, LoadResolved, LoadUnresolved } from "../../../Logic/Enquiries/Load";
import { getLastTouched, saveLastTouched } from "../../../Logic/LastTouched/misc";
import { setEnquiryAndWorkflowInvisible, setShowWizard } from "../../../state/restrictedViewSlice";
import { setWorkflowVisible } from "../../../state/secondColSlice";
import { RootState, useAppDispatch } from "../../../state/store";
import { setTabVisibility } from "../../../state/tabRow";
import { showHideLoader } from "../../../utilities/loading";
import { getActiveListEnquiries } from "../../../utilities/localStore/calls";
import { resetSort } from "../../../utilities/sort";
import DropdownBasic from "../../Generic/DropdownBasic";
import { EnquiryBurgerMenu } from "../../Menu";
import "./index.scss";
function Tabs({ FullWidth }: { FullWidth: boolean }) {
    const User = useSelector((state: RootState) => state.UserInformation);
    const secondCol = useSelector((state: RootState) => state.secondCol);
    const dispatch = useAppDispatch();
    const RestrictedWidthState = useSelector((state: RootState) => state.restrictedView);
    const tabState = useSelector((state: RootState) => state.tabRow.tabs).find(x => x.active == true);
    const activeEnquiry = useSelector((state: RootState) => state.activeEnquiry);
    let eNQ = getEnquiryById(tabState?.enquiryId ?? 0);
    const [DropdownLabel, setDropDownLabel] = useState("");
    const [enabled, setEnabled] = useState(true);
    const { selectionProperties, SetEnquiryGridSelectionProperties } = useContext(EnquiryGridSelectionContext);
    const enquiriesCache = useSelector((state: RootState) => state.EnquiryCache.data);
    const [date, setDate] = useState("");

    async function refreshInterface() {
        LoadActiveMyEnquiries();
    }

    useEffect(() => {
        if (getLastTouched().MyEnquiries.DateCompleted !== undefined)
            setDate(getLastTouched().MyEnquiries.DateCompleted ?? "");
        else {
            const today = new Date();
            const formatted = today.toISOString().split("T")[0];
            setDate(formatted);
        }
    }, []);

    function getCompletedCases(dateCompleted: string) {
        setDate(dateCompleted);
        const iLastTouched = getLastTouched();
        iLastTouched.MyEnquiries.DateCompleted = dateCompleted;
        saveLastTouched(iLastTouched);
        LoadActiveMyEnquiries();
    }

    const today = new Date();
    const maxDate = today.toISOString().split("T")[0];

    function back() {
        dispatch(setTabVisibility(10.35));
        dispatch(setWorkflowVisible(false));
        dispatch(setEnquiryAndWorkflowInvisible(false));
    }
    async function displayActiveEnquiry() {
        if (activeEnquiry.id > 11) {
            await new ActivateWizardModule().showEnquiry(activeEnquiry.id);
        }
    }
    useInterval(() => refreshInterface(), 60 * 1000);
    useWindowResize(burgerMenuMatchLeftPanePos);
    useEffect(burgerMenuMatchLeftPanePos, []);
    useEffect(() => {
        const iLastTouched = getLastTouched();
        let Lists = getActiveListEnquiries();
        if (iLastTouched.MyEnquiries.ActiveList == "Unresolved") {
            setDropDownLabel(`Unresolved (${Lists?.length})`);
        } else if (iLastTouched.MyEnquiries.ActiveList == "Resolved") {
            setDropDownLabel(`Completed (${Lists?.length})`);
        }
    }, [enquiriesCache]);

    return (
        <>
            <div
                className="enquiries-navigation"
                id="MyEnquiriesHeader"
            >
                {FullWidth == false && RestrictedWidthState.showEnquiry == true && tabState?.enquiryId! < 11 && (
                    <>
                        <div className="col-xs-5">
                            <div className="enquiries-tabs"></div>
                        </div>
                        <div className="col-xs-7 d-flex align-items-center">
                            <button
                                className="g-tab g-default-tab-padding"
                                onClick={() => {
                                    back();
                                }}
                            >
                                Enquiry List
                            </button>
                            <button className="g-tab-selected g-default-tab-padding">Selected Enquiry</button>
                            <EnquiryBurgerMenu
                                key={"burger-menu-dropdown"}
                                enquiryIds={
                                    !selectionProperties.multiSelect
                                        ? [activeEnquiry.id]
                                        : selectionProperties.selectedEnquiries.map(x => parseInt(x))
                                }
                            />
                        </div>
                    </>
                )}
                {RestrictedWidthState.showEnquiry &&
                    FullWidth == false &&
                    tabState?.enquiryId! > 11 &&
                    eNQ !== undefined && (
                        <>
                            <div className="col-xs-5 overflowText">
                                <div className="enquiries-tabs">
                                    Enquiry Wizard - {eNQ.enquiryReference + " - " + eNQ.subject}
                                </div>
                            </div>
                            <div
                                className="col-xs-7"
                                style={{ minWidth: "300px" }}
                            >
                                {RestrictedWidthState.showWizard && (
                                    <>
                                        <button
                                            className="g-tab g-default-tab-padding "
                                            onClick={() => {
                                                dispatch(setShowWizard(false));
                                            }}
                                        >
                                            Selected Enquiry
                                        </button>
                                        <button className="g-tab-selected g-default-tab-padding">Active Wizard</button>
                                    </>
                                )}
                                {!RestrictedWidthState.showWizard && (
                                    <>
                                        <button className="g-tab-selected g-default-tab-padding">
                                            Selected Enquiry
                                        </button>
                                        <button
                                            className="g-tab g-default-tab-padding "
                                            onClick={() => {
                                                dispatch(setShowWizard(true));
                                            }}
                                        >
                                            Active Wizard
                                        </button>
                                    </>
                                )}
                            </div>
                        </>
                    )}

                {(FullWidth == true ||
                    activeEnquiry.id < 11 ||
                    (FullWidth == false && !RestrictedWidthState.showEnquiry)) && (
                    <div className="col-xs-2">
                        <div className="enquiries-tabs">
                            <button
                                className="enquiry-refresh-button"
                                title="Refresh"
                                onClick={async () => {
                                    if (enabled) {
                                        setEnabled(false);
                                        resetSort();
                                        refreshInterface();
                                        setTimeout(() => {
                                            setEnabled(true);
                                        }, 5000);
                                    } else {
                                        showHideLoader("flex");
                                        setTimeout(() => {
                                            showHideLoader("none");
                                        }, 1000);
                                    }
                                }}
                            >
                                <BsArrowClockwise
                                    style={{
                                        marginTop: "-2px",
                                        cursor: "pointer",
                                        rotate: "90deg",
                                        width: "14px",
                                        height: "14px",
                                    }}
                                ></BsArrowClockwise>
                            </button>
                            <DropdownBasic
                                id={22}
                                label={DropdownLabel}
                            >
                                <li>
                                    <button
                                        title="Unresolved Enquiries"
                                        onClick={() => {
                                            resetSort();
                                            SetEnquiryGridSelectionProperties(currentState => {
                                                currentState.multiSelect = false;
                                                currentState.selectedEnquiries = [];
                                                return currentState;
                                            });
                                            const iLastTouched = getLastTouched();
                                            iLastTouched.MyEnquiries.ActiveList = "Unresolved";
                                            iLastTouched.lastActiveListType = "Unresolved";
                                            saveLastTouched(iLastTouched);
                                            LoadUnresolved();
                                        }}
                                    >
                                        Unresolved
                                    </button>
                                </li>
                                <li>
                                    <button
                                        title="Completed Enquiries"
                                        onClick={() => {
                                            resetSort();
                                            SetEnquiryGridSelectionProperties(currentState => {
                                                currentState.multiSelect = false;
                                                currentState.selectedEnquiries = [];
                                                return currentState;
                                            });
                                            const iLastTouched = getLastTouched();
                                            iLastTouched.MyEnquiries.ActiveList = "Resolved";
                                            iLastTouched.lastActiveListType = "Resolved";
                                            saveLastTouched(iLastTouched);
                                            LoadResolved();
                                        }}
                                    >
                                        Completed
                                    </button>
                                </li>
                            </DropdownBasic>{" "}
                            {getLastTouched() !== null && getLastTouched().MyEnquiries.ActiveList == "Resolved" && (
                                <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                    <button
                                        title="Previous Day"
                                        className="completed-arrows-button"
                                        onClick={e => {
                                            const dateObject = new Date(date);
                                            dateObject.setDate(dateObject.getDate() - 1);
                                            getCompletedCases(dateObject.toISOString().split("T")[0]);
                                        }}
                                    >
                                        <BsCaretLeftFill size={10}></BsCaretLeftFill>
                                    </button>
                                    <button
                                        title="Next Day"
                                        className="completed-arrows-button"
                                        onClick={e => {
                                            const dateObject = new Date(date);
                                            dateObject.setDate(dateObject.getDate() + 1);
                                            getCompletedCases(dateObject.toISOString().split("T")[0]);
                                        }}
                                    >
                                        <BsCaretRightFill size={10}></BsCaretRightFill>
                                    </button>
                                    <input
                                        type="date"
                                        max={maxDate}
                                        className="g-TextBox-default ms-1"
                                        onChange={e => getCompletedCases(e.target.value)}
                                        value={date}
                                    />
                                </div>
                            )}
                        </div>{" "}
                    </div>
                )}
                {FullWidth == false && !RestrictedWidthState.showEnquiry && !RestrictedWidthState.showWizard && (
                    <div
                        style={{ display: "flex", alignItems: "center" }}
                        className="col-xs-7"
                    >
                        {selectionProperties.multiSelect ? (
                            <div style={{ float: "right", fontSize: "9pt", margin: "1px 5px" }}>
                                {selectionProperties.selectedEnquiries.length} selected of{" "}
                                {getActiveListEnquiries()?.length}{" "}
                            </div>
                        ) : (
                            ""
                        )}
                        <button className="g-tab-selected g-default-tab-padding">Enquiry List</button>
                        <button
                            className="g-tab g-default-tab-padding"
                            onClick={() => {
                                displayActiveEnquiry();
                            }}
                        >
                            Selected Enquiry
                        </button>
                        <div
                            className={
                                selectionProperties.multiSelect == false ? "icon-button" : "icon-button-selected"
                            }
                        >
                            <BsCheck2Square
                                style={{ width: "14px", height: "14px" }}
                                title={"Select Multiple"}
                                onClick={() => {
                                    SetEnquiryGridSelectionProperties(currentState => {
                                        currentState = JSON.parse(JSON.stringify(currentState));
                                        currentState.multiSelect = currentState.multiSelect == false ? true : false;
                                        currentState.selectedEnquiries =
                                            currentState.multiSelect == false ? [] : currentState.selectedEnquiries;
                                        return currentState;
                                    });
                                }}
                            ></BsCheck2Square>
                        </div>{" "}
                        <EnquiryBurgerMenu
                            key={"burger-menu-dropdown"}
                            enquiryIds={
                                !selectionProperties.multiSelect
                                    ? [activeEnquiry.id]
                                    : selectionProperties.selectedEnquiries.map(x => parseInt(x))
                            }
                        />
                    </div>
                )}
                {FullWidth == true && (
                    <div
                        className="col-xs-7"
                        id="enquiry-drpdown"
                        style={{}}
                    ></div>
                )}
            </div>
        </>
    );
}

export default Tabs;
